import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import NotFound404 from 'asset/illustration/not-found-404.svg';
import internalServerError from 'asset/illustration/internal-server-error.svg';
import { CircularProgress } from '@mui/material';
import UserCampaign from 'Pages/InProgress';
import MSearch from 'Pages/MSearch';
import { STRING_CONFIG } from 'utils';
import DeleteMyAccount from 'Pages/DeleteMyAccount';
import { useAdTray } from 'contexts/AdTrayContext';
import AdTray from 'Pages/Components/AdTray';
import Toast from 'ReusableComponents/Toast';
import PrivateRoute from './PrivateRoute';
import AuthModal from 'Pages/Components/AuthModal';
import UserAuthentication from 'Pages/Blogs/Components/userAuthentication';
import { useDispatch, useSelector } from 'react-redux';
import { showAuthModal } from 'store/auth/actions';
import ProtectedRoute from './ProtectedRoute';
import blogData from 'content/platform/blog.json';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';


const Blogs = lazy(() => import('Pages/Blogs'));

const Browse = lazy(() => import('Pages/Browse'));

const CommunityGuidelines = lazy(() => import('Pages/CommunityGuidelines'));

const Corporate = lazy(() => import('Pages/Corporate'));

const EmailVerificationCheckEmail = lazy(
  () => import('Pages/EmailVerificationCheckEmail')
);

const ErrorPages = lazy(() => import('ReusableComponents/ErrorPages'));

const SelectStore = lazy(() => import('Pages/SelectStore'));

const HelpCenter = lazy(() => import('Pages/HelpCenter'));

const HelpCenterTopicOne = lazy(
  () => import('Pages/HelpCenter/HelpCenterTopicOne')
);

const HelpCenterTopicTwo = lazy(
  () => import('Pages/HelpCenter/HelpCenterTopicTwo')
);

const HelpCenterTopicThree = lazy(
  () => import('Pages/HelpCenter/HelpCenterTopicThree')
);

const HelpCenterTopicFour = lazy(
  () => import('Pages/HelpCenter/HelpCenterTopicFour')
);

const HelpCenterTopicFive = lazy(
  () => import('Pages/HelpCenter/HelpCenterTopicFive')
);

const HelpCenterTopicSix = lazy(
  () => import('Pages/HelpCenter/HelpCenterTopicSix')
);

const HelpCenterTopicSeven = lazy(
  () => import('Pages/HelpCenter/HelpCenterTopicSeven')
);

const HelpCenterTopicEight = lazy(
  () => import('Pages/HelpCenter/HelpCenterTopicEight')
);

const HelpCenterTopicNine = lazy(
  () => import('Pages/HelpCenter/HelpCenterTopicNine')
);

const HelpCenterTopicTen = lazy(
  () => import('Pages/HelpCenter/HelpCenterTopicTen')
);

const HelpCenterTopicEleven = lazy(
  () => import('Pages/HelpCenter/HelpCenterTopicEleven')
);

const HelpCenterTopicTwelve = lazy(
  () => import('Pages/HelpCenter/HelpCenterTopicTwelve')
);

const HelpCenterTopicThirteen = lazy(
  () => import('Pages/HelpCenter/HelpCenterTopicThirteen')
);

const HelpCenterTopicFourteen = lazy(
  () => import('Pages/HelpCenter/HelpCenterTopicFourteen')
);

const Explore = lazy(() => import('Pages/Explore'));

const InitiateForgotPassword = lazy(
  () => import('Pages/InitiateForgotPassword')
);

const MyAccount = lazy(() => import('Pages/MyAccount'));

const MostUpvotedProducts = lazy(
  () => import('Pages/ProductsByCategory/MostUpvotedProducts')
);

const MostReviewedProducts = lazy(
  () => import('Pages/ProductsByCategory/MostReviewedProducts')
);

const MostViewedProducts = lazy(
  () => import('Pages/ProductsByCategory/MostViewedProducts')
);

const PlatformSearch = lazy(() => import('Pages/PlatformSearch'));

const PrivacyPolicy = lazy(() => import('Pages/PrivacyPolicy'));

const ProductCompare = lazy(() => import('Pages/ProductCompare'));

const ForYou = lazy(() => import('Pages/ForYou'));

const Product = lazy(() => import('Pages/Product'));

const ReportUser = lazy(() => import('Pages/ReportUser'));

const ReviewDetails = lazy(() => import('Pages/ReviewDetails'));

const ShopTogether = lazy(() => import('Pages/ShopTogether'));

const SignUpEmailVerification = lazy(
  () => import('Pages/SignUpEmailVerification')
);

const TermsOfService = lazy(() => import('Pages/TermsOfService'));

const UserProfile = lazy(() => import('Pages/UserProfile'));

const VerifyForgotPassword = lazy(() => import('Pages/VerifyForgotPassword'));

const UserAccessView = lazy(() => import('Routes/UserAccessView'));

function Routes({ location }) {
  const Style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
  };

  const dispatch = useDispatch();

  const { showAdTray, isPaymentSuccess } = useAdTray();

  const isModalOpen = useSelector((state) => state.auth.isModalOpen);

  const activeBlogId = useSelector(
    (state) => state.platform.activeBlogId || 1
  );

  const activeBlog =
    blogData.articles.find(
      (article) => article.id === Number(activeBlogId)
    ) || blogData.articles[0];

  useEffect(() => {
    dispatch(showAuthModal(false));
  }, [])

  return (
    <Suspense
      fallback={
        <div style={Style}>
          <CircularProgress />
        </div>
      }
    >
      <Switch>
        <Route exact path='/' component={UserAccessView} />
        <Route exact path='/blogs'>
          <Redirect to={`/blogs/${activeBlog.slug}-${activeBlog.id}`} />
        </Route>
        <Route exact path='/blogs/:slug-:id' component={Blogs} />
        <Route
          exact
          path='/community-guidelines'
          component={CommunityGuidelines}
        />
        <Route exact path='/corporate' component={Corporate} />
        <Route
          exact
          path='/create-new-password/:token'
          component={VerifyForgotPassword}
        />
        <Route
          path='/email-verification'
          component={EmailVerificationCheckEmail}
        />
        <Route
          exact
          path='/explorepage/:token'
          component={SignUpEmailVerification}
        />
        <Route exact path='/help-center' component={HelpCenter} />
        <Route
          exact
          path='/help-getting-started-with-reviewdale'
          component={HelpCenterTopicOne}
        />
        <Route
          exact
          path='/help-browsing-and-searching-products'
          component={HelpCenterTopicTwo}
        />
        <Route
          exact
          path='/help-product-comparison-tool'
          component={HelpCenterTopicThree}
        />
        <Route
          exact
          path='/help-explore-ad-free-experience'
          component={HelpCenterTopicFour}
        />
        <Route
          exact
          path='/help-writing-and-submitting-product-review'
          component={HelpCenterTopicFive}
        />
        <Route
          exact
          path='/help-asking-questions-about-products'
          component={HelpCenterTopicSix}
        />
        <Route
          exact
          path='/help-commenting-on-review-and-discussion'
          component={HelpCenterTopicSeven}
        />
        <Route
          exact
          path='/help-answering-questions-from-community'
          component={HelpCenterTopicEight}
        />
        <Route
          exact
          path='/help-managing-reviewdale-account'
          component={HelpCenterTopicNine}
        />
        <Route
          exact
          path='/help-saving-and-organizing-favorites'
          component={HelpCenterTopicTen}
        />
        <Route
          exact
          path='/help-setting-up-alert-and-notifications'
          component={HelpCenterTopicEleven}
        />
        <Route
          exact
          path='/help-contacting-support-for-assistance'
          component={HelpCenterTopicTwelve}
        />
        <Route
          exact
          path='/help-report-bug'
          component={HelpCenterTopicThirteen}
        />
        <Route
          exact
          path='/help-new-feature-request'
          component={HelpCenterTopicFourteen}
        />
        <Route
          exact
          path='/initiate-forgot-password'
          component={InitiateForgotPassword}
        />
        <Route exact path='/privacy-policy' component={PrivacyPolicy} />
        <Route path='/shop/session/:sessionId' component={ShopTogether} />
        <Route exact path='/terms-of-service' component={TermsOfService} />
        <Route exact path='/user-campaign' component={UserCampaign} />

        {/* Private Routes Below */}
        <PrivateRoute
          exact
          path='/most-reviewed-products'
          component={MostReviewedProducts}
        />
        <PrivateRoute
          exact
          path='/most-upvoted-products'
          component={MostUpvotedProducts}
        />
        <PrivateRoute
          exact
          path='/most-viewed-products'
          component={MostViewedProducts}
        />
        <PrivateRoute exact path='/browse' component={Browse} />
        <PrivateRoute exact path='/compare' component={ProductCompare} />
        <ProtectedRoute exact path='/delete-my-account' component={DeleteMyAccount} />
        <PrivateRoute exact path='/for-you' component={ForYou} />
        <PrivateRoute exact path='/explore' component={Explore} />
        <ProtectedRoute exact path='/my-account' component={MyAccount} />
        <Route exact path='/store/:pcode/:slug' component={SelectStore} />
        <Route exact path='/store/:pcode' component={SelectStore} />
        <Route exact path='/product/:code/:slug' component={Product} />
        <Route exact path='/product/:code' component={Product} />
        <Route path='/product/:pCode/:slug/review/:rId' component={ReviewDetails} />
        <Route path='/product/:pCode/review/:rId' component={ReviewDetails} />
        <PrivateRoute path='/profile/:username' component={ReportUser} />
        <PrivateRoute exact path='/search/:query' component={PlatformSearch} />
        <PrivateRoute exact path='/search' component={MSearch} />
        <ProtectedRoute exact path='/user-profile' component={UserProfile} />
        <Route
          path='*'
          component={() => (
            <ErrorPages
              title={STRING_CONFIG.inPage.common.txtError404Title}
              subtitle={STRING_CONFIG.inPage.platform.txtError404Subtext}
              img={NotFound404}
            />
          )}
        />
        <Route
          path='/internal-server-error'
          component={() => (
            <ErrorPages
              title={STRING_CONFIG.inPage.common.txtError500Title}
              subtitle={STRING_CONFIG.inPage.platform.txtError500Subtext}
              img={internalServerError}
            />
          )}
        />
        <Route
          path='/page-not-found'
          component={() => (
            <ErrorPages
              title={STRING_CONFIG.inPage.common.txtError404Title}
              subtitle={STRING_CONFIG.inPage.platform.txtError404Subtext}
              img={NotFound404}
            />
          )}
        />
      </Switch>
      <Toast />
      {/* {showAdTray && !isPaymentSuccess && <AdTray />} */}
      <AuthModal
        isOpen={isModalOpen}
        onClose={() => dispatch(showAuthModal(false))}
      >
        <UserAuthentication />
      </AuthModal>
    </Suspense>
  );
}

export default withRouter(Routes);